export default "__VITE_ASSET__3484e499__"